module.exports = __webpack_public_path__ + "img/icon-email.16bd19e1.svg";